import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { MessageService } from 'primeng/api';
import { DocumentsService } from '../service/documents.service';

@Component({
  selector: 'app-notificaciones',
  templateUrl: './notificaciones.component.html',
  styleUrls: ['./notificaciones.component.css'],
  providers: [MessageService]
})
export class NotificacionesComponent implements OnInit {

  devueltos: any[] = [];
  loading = false;
  // Marca en curso por id de documento, para deshabilitar el botón mientras responde la API.
  marcandoIds: { [id: string]: boolean } = {};

  constructor(
    private docsService: DocumentsService,
    private messageService: MessageService) { }

  ngOnInit() {
    this.cargarDevueltos();
  }

  get totalNoLeidos(): number {
    return this.devueltos.length;
  }

  cargarDevueltos() {
    this.loading = true;
    this.docsService.getAlertasDevueltos().subscribe(
      result => {
        let data = (result && result['data']) ? result['data'] : [];
        this.devueltos = data.map(d => this.buildAlerta(d));
        this.loading = false;
      },
      error => {
        console.error('Error al cargar alertas de devueltos', error);
        this.loading = false;
      }
    );
  }

  // Formatea los campos que se muestran en la lista.
  buildAlerta(d: any): any {
    let estado = d['estado_ultimo'] || {};
    d['obs'] = estado['observaciones'] || '';
    if (d['uploadDate']) {
      d['fecha_presentacion'] = formatDate(d['uploadDate'], 'dd-MM-yyyy HH:mm', 'en-US', '+000');
    }
    if (estado['fecha_estado']) {
      d['fecha_devolucion'] = formatDate(estado['fecha_estado'], 'dd-MM-yyyy HH:mm', 'en-US', '+000');
    }
    return d;
  }

  marcarLeida(doc: any) {
    if (this.marcandoIds[doc.id]) return;
    this.marcandoIds[doc.id] = true;

    this.docsService.marcarAlertaLeida(doc.id).subscribe(
      () => {
        // Sacamos la alerta de la lista para que baje el contador y no se vuelva a informar.
        this.devueltos = this.devueltos.filter(d => d.id !== doc.id);
        delete this.marcandoIds[doc.id];
        this.messageService.add({ severity: 'success', summary: '', detail: 'Notificación marcada como leída.' });
      },
      error => {
        console.error('Error al marcar alerta como leída', error);
        delete this.marcandoIds[doc.id];
        this.messageService.add({ severity: 'error', summary: '', detail: 'No se pudo marcar como leída. Intente nuevamente.' });
      }
    );
  }

}
